import { render, staticRenderFns } from "./VoyagaYetmaganlar.vue?vue&type=template&id=5034ebbc&scoped=true&"
import script from "./VoyagaYetmaganlar.vue?vue&type=script&lang=js&"
export * from "./VoyagaYetmaganlar.vue?vue&type=script&lang=js&"
import style0 from "./VoyagaYetmaganlar.vue?vue&type=style&index=0&id=5034ebbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034ebbc",
  null
  
)

export default component.exports